import React from "react";
import ChangePasswordRoute from "../components/auth/ChangePasswordRoute";
import ChangePassword from "../pages/Authentication/ChangePassword";
import UserSessionManager from "../utils/UserSessionManager";
import MainLayout from "./main";

export default function ChangePasswordLayout() {
  const forced = UserSessionManager.requiresPasswordChange();

  if (forced) {
    return (
      <ChangePasswordRoute>
        <div className="d-flex flex-column min-vh-100 bg-light">
          <main className="flex-fill">
            <ChangePassword />
          </main>
        </div>
      </ChangePasswordRoute>
    );
  }

  return (
    <ChangePasswordRoute>
      <MainLayout>
        <ChangePassword />
      </MainLayout>
    </ChangePasswordRoute>
  );
}
